import { render, staticRenderFns } from "./_Confirm.vue?vue&type=template&id=c5e7a0b8&scoped=true&"
import script from "./_Confirm.vue?vue&type=script&lang=js&"
export * from "./_Confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e7a0b8",
  null
  
)

export default component.exports